module.exports = __webpack_public_path__ + "img/majdacraft.1830fd7d.jpg";